import {React,useEffect,useReducer,useState} from 'react'
import {Homeproduction} from './Fetcher'
import Product from './Product'

const initaistate ={
 
  loading : true,
  data : [],
  error : '',

}


const reducer = (state,action)=>{
switch(action.type){
  case 'sucess' :
    return{...state,
      loading: false ,
      data: action.payload,
      error: ''
    }
case 'error' :
  return{...state,
    loading: false ,
    data: [],
    error: action.errormessage
  }
}
}



export const Homeproduct1 = () => {

const[pignation,setpignation]=useState(10)
  
  const [ productdata , dispatch] = useReducer(reducer,initaistate)
  useEffect(()=>{
    Homeproduction({dispatch:dispatch})
  },[])


  let clickmore=()=>{
    setpignation(prev=>prev+3)
  }

    
  const rerenderproduct=()=>{
    return  productdata.data.map(data=>(
     <Product key={data.id} data={data}/>
    
    ))
  }

 
  return (
    <div>
{rerenderproduct()}


    </div>
  )
}

export default Homeproduct1